var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeeplayColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9638D2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.1,428.5c32,0,56.6,16.2,66.8,31.1V317.7h63.5v347.7h-63.5v-26c-10.2,14.8-34.8,31.1-66.8,31.1 c-61.7,0-109-55.2-109-121C147.2,483.7,194.5,428.5,256.1,428.5z M269.6,486.4c-34.8,0-58.4,26.9-58.4,63.1s23.6,63.1,58.4,63.1 s58.4-26.9,58.4-63.1C328,513.3,304.3,486.4,269.6,486.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M526.8,428.5c60.7,0,114.1,38.9,114.1,114.1c0,5.6,0,12.1-0.9,21.8H466.5c3.7,31.1,31.1,48.2,61.7,48.2 c28.7,0,49.6-13.4,59.8-29.2l47.3,35.2c-21.3,31.1-58.9,51.9-107.6,51.9c-69.1,0-122.9-47.8-122.9-121 C404.9,480.9,456.3,428.5,526.8,428.5z M468.9,521.2h108.5c-5.6-27.4-28.7-40.3-52.4-40.3C501.3,480.9,474.9,492.9,468.9,521.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M780.9,428.5c60.7,0,114.1,38.9,114.1,114.1c0,5.6,0,12.1-0.9,21.8H720.6c3.7,31.1,31.1,48.2,61.7,48.2 c28.7,0,49.6-13.4,59.8-29.2l47.3,35.2c-21.3,31.1-58.9,51.9-107.6,51.9c-69.1,0-122.9-47.8-122.9-121 C658.9,480.9,710.4,428.5,780.9,428.5z M722.9,521.2h108.5c-5.6-27.4-28.7-40.3-52.4-40.3C755.4,480.9,728.9,492.9,722.9,521.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M911.6,433.6h63.5v26c10.7-14.8,35.2-31.1,67.2-31.1c61.7,0,109,55.2,109,121s-47.3,121-109,121 c-32,0-56.6-16.2-67.2-31.1v122.9h-63.5L911.6,433.6L911.6,433.6z M1028.5,486.4c-34.8,0-58.4,26.9-58.4,63.1s23.6,63.1,58.4,63.1 s58.4-26.9,58.4-63.1C1086.9,513.3,1063.2,486.4,1028.5,486.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1169.9,317.7h63.5v347.7h-63.5V317.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1360.8,428.5c32,0,56.6,16.2,66.8,31.1v-26h63.5v231.8h-63.5v-26c-10.2,14.8-34.8,31.1-66.8,31.1 c-61.7,0-109-55.2-109-121S1299.1,428.5,1360.8,428.5z M1374.2,486.4c-34.8,0-58.4,26.9-58.4,63.1s23.6,63.1,58.4,63.1 s58.4-26.9,58.4-63.1C1432.6,513.3,1409,486.4,1374.2,486.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1558.2,762.3l48.7-109.9l-97.4-218.8h69.5l62.1,150.2l61.7-150.2h70l-145.6,328.7H1558.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeeplayColor);
export default __webpack_public_path__ + "static/media/deeplay_color.409340205bdb0ec8e5f2b55d9972f293.svg";
export { ForwardRef as ReactComponent };